'use client';
import { useHydrate } from '@benzinga/hooks';
import { useIsUserLoggedIn } from '@benzinga/user-context';
import { getRegisterType } from '@benzinga/utils';
import { usePathname, useRouter } from 'next/navigation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n, { LocaleType } from '@benzinga/translate';
import { getRegisterTypeByLocale } from '@benzinga/identity';

export const SimpleAccount: React.FC = () => {
  const { t } = useTranslation('common');
  const isLoggedIn = useHydrate(useIsUserLoggedIn(), false);

  const router = useRouter();
  const pathname = usePathname();

  const requestAuth = React.useCallback(() => {
    const redirectUrl = new URL(`${window.location.origin}/login?action=register&next=${window.location.href}`);

    const register_type = getRegisterTypeByLocale(i18n.language as LocaleType) ?? getRegisterType(pathname || '');
    if (register_type) {
      redirectUrl.searchParams.append('utm_source', register_type);
    }

    window.location.href = redirectUrl.toString();
  }, [pathname]);

  const logout = React.useCallback(() => {
    let next = window.location.href;
    if (next.includes('/account')) {
      next = window.location.origin;
    }
    next = encodeURIComponent(next);

    const url = new URL(`${window.location.origin}/logout?next=${next}`);
    router.push(url.toString());
  }, [router]);

  return (
    <div className="text-sm font-semibold">
      {isLoggedIn ? (
        <button className="auth-link-button" onClick={logout}>
          {t('Navigation.AccountMenu.my-account-text')}
        </button>
      ) : (
        <button className="auth-link-button" onClick={requestAuth}>
          {t('Navigation.TopBar.sign-in')}
        </button>
      )}
    </div>
  );
};
